import { Component, h } from 'preact';
import cx from 'classnames';
import { route } from 'preact-router';

import { Inquiry } from '../../../../../types/inquiries';
import { ReqState } from '../../../../../types/request-state.model';

import getStore from '../../../store';
import * as InquiriesActions from '../../../reducers/inquiries/inquiries.actions';

import { inquiryService } from '../../../../utils/inquiry.service';
import { DatePickerControl } from '../../common/date-picker-control.component';
import { HopplerModalizer } from '../../common/hoppler-modalizer.component';
import { InqStageTransitionContent } from '../documents/inq-stage-transition-content.component';


interface ScheduleViewingModalProps {
  inquiry: Inquiry;
  onClose?: () => void;
}

interface ScheduleViewingModalState {
  requestStatus?: ReqState;
  date?: string;
  errorMessage?: string;
  timeFrom?: string;
  timeTo?: string;
}

const store = getStore();

export class ScheduleViewingModal extends Component<ScheduleViewingModalProps, ScheduleViewingModalState> {
  onProceed() {
    this.props.onClose();
    store.dispatch(InquiriesActions.loadAllStages());
    route('/kumita-brokers/inquiries/viewings-scheduled?actionFrom=ccp03');
  }

  isSubmitButtonEnabled() {
    const state = this.state;

    const paramsComplete = (
      !!state.date
    );
    const reqInProgress = state.requestStatus == ReqState.IN_PROGRESS;

    return paramsComplete && !reqInProgress;
  }

  async handleSubmit(event: Event) {
    event.preventDefault();
    const inquiry = this.props.inquiry;

    this.setState({ requestStatus: ReqState.IN_PROGRESS });
    try {
      const res = await inquiryService.scheduleViewing(inquiry.inquiryCode, this.state.date);

      this.setState({ requestStatus: ReqState.SUCCESS });
    } catch (error) {
      let message;
      if (error.response.data && error.response.data.msg) {
        message = error.response.data.msg;
      }

      this.setState({
        errorMessage: message || 'Something went wrong.',
        requestStatus: ReqState.FAILED,
      })
    }
  }

  getModalBody(props: ScheduleViewingModalProps, state: ScheduleViewingModalState) {
    return (
      <form className="hi-schedviewmodal__content" onSubmit={ event => this.handleSubmit(event) }>
        <div className="hi-input-group">
          <label className="hi-input-group__label">Select Date</label>
          {/*
            The mildly awkward validation logic here was preserved during the
            upgrade from HopplerDatePicker to DatePickerControl. Validation for
            this modal as a whole should be fixed up in a separate task.
          */}
          <DatePickerControl value={state.date}
            onChange={evt => this.setState({ date: evt.target['value'] })}
            className={cx('form-control', {
              'is-invalid': state.requestStatus === ReqState.FAILED
            })} />

          {state.requestStatus == ReqState.FAILED ?
            <small className="text-danger">{state.errorMessage}</small>
            : null}
        </div>

        {/*
          The time inputs are supposed to be tagged to specific properties.
          As we don't support that functionality yet, we'll just leave this commented out.
        */}
        {/* <div className="hi-input-group">
          <label className="hi-input-group__label">Select Time (From - To)</label>
          <div className="d-flex">
            <TimePickerControl className="form-control w-50 hi-border-radius-right-0"
              name="timeFrom"
              onChange={ linkState(this, 'timeFrom') }
              value={ state.timeFrom } />


            <TimePickerControl className="form-control w-50 hi-border-radius-left-0"
              name="timeTo"
              onChange={ linkState(this, 'timeTo') }
              value={ state.timeTo }  />
          </div>
        </div> */}

        <div className="text-center">
          <button type="submit" className="btn btn-secondary px-5"
            disabled={ !this.isSubmitButtonEnabled() }>
            <span>
              {state.requestStatus == ReqState.IN_PROGRESS ? 'Setting...' : 'Set'}
            </span>
          </button>
        </div>
      </form>
    )
  }

  getSuccessMessageBody(props: ScheduleViewingModalProps, state: ScheduleViewingModalState) {
    return (
      <InqStageTransitionContent headingText='Successfully Scheduled'
        targetName='Viewings Scheduled'
        onProceed={ () => this.onProceed() }
        onClose={ props.onClose } />
    )
  }

  render(props: ScheduleViewingModalProps, state: ScheduleViewingModalState) {
    return (
      <HopplerModalizer onClose={ () => null }>
        <section className="hi-schedviewmodal">
          <div className="hi-schedviewmodal__title-bar">
            <span className="hi-schedviewmodal__title-label">Schedule Viewing</span>

            <button
              onClick={ props.onClose }
              className="btn btn-link hi-schedviewmodal__title-close">
              <i className="fas fa-times" /> Close
            </button>
          </div>

          <div className="hi-schedviewmodal__body">
            {
              state.requestStatus === ReqState.SUCCESS ?
                this.getSuccessMessageBody(props, state) :
                this.getModalBody(props, state)
            }
          </div>
        </section>
      </HopplerModalizer>
    );
  }
}